import { useAtomValue } from 'jotai';
import { isOnlineUserAtom } from '../atom/Atom';
import { ChangeImageWhenHover } from './ChangeImageWhenHover';

interface BackToTownButtonProps {
  buttonType?: 'hover' | 'simple' | 'square';
}

const LABEL_BACK_TO_TOWN = 'タウンにもどる';

export const BackToTownButton = ({ buttonType = 'simple' }: BackToTownButtonProps) => {
  const env = import.meta.env;
  const isOnlineUser = useAtomValue(isOnlineUserAtom);

  if (!isOnlineUser) {
    return null;
  }

  const href = `${env.VITE_DIGITANE_TOWN_URL}`;

  switch (buttonType) {
    case 'hover':
      return (
        <a href={href}>
          <ChangeImageWhenHover
            frameClassName="!fixed top-[7%] left-[1%] w-[15%] flex items-center"
            src="/common/buttons/back_town_button"
            alt={LABEL_BACK_TO_TOWN}
          />
        </a>
      );

    case 'simple':
      return (
        <a href={href} className="px-16 py-2 text-2xl text-white bg-main_text rounded-3xl border-white border-4 cursor-pointer">
          {LABEL_BACK_TO_TOWN}
        </a>
      );

    case 'square':
      return (
        <a href={href}>
          <span className="p-6 text-white rounded font-extrabold bg-current_key">{LABEL_BACK_TO_TOWN}</span>
        </a>
      );

    default:
      return <a href={href}>{LABEL_BACK_TO_TOWN}</a>;
  }
};
